<template>
  <div class="c-adcount-selecter">
    <Button @click="visiable = true">
      <span class="item-btn-span" v-if="len">已选{{ len }}个账号</span>
      <span class="item-btn-span" v-else>请选择管控账号</span>
      <Icon type="ios-arrow-down" />
    </Button>
    <manage-adcount v-model="visiable" :selector="value" :media-ids="filterAcounts" @on-select="submit" />
  </div>
</template>
<script>
import ManageAdcount from './manage-adcount.vue'
export default {
  name: 'adcountSelecter',
  components: { ManageAdcount },
  props: {
    value: {
      type: Array
    },
    filterAcounts: {
      type: Array
    }
  },
  computed: {
    len() {
      return this.value.length
    }
  },
  data() {
    return {
      visiable: null
    }
  },
  methods: {
    submit(val) {
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-adcount-selecter {
  position: relative;

  .item-btn-span {
    margin-right: 12px;
  }

  .m-selecter {
    position: relative;
  }
}
</style>
